import { inject, InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AppsFlyerService, DeepLinkService } from '../services';
import { AppsFlyerOneLinkParams } from '../interfaces';

export const DEEP_LINK_TOKEN: InjectionToken<DeepLinkProvider> = new InjectionToken<DeepLinkProvider>(
  'DEEP_LINK_TOKEN',
  {
    factory: (): DeepLinkProvider => {
      const deepLinkService: DeepLinkService = inject(DeepLinkService);
      const appsFlyerService: AppsFlyerService = inject(AppsFlyerService);

      return {
        generateWebLink(path: string): string {
          return deepLinkService.generateWebLink(path);
        },
        generateAppsFlyerLink(url: string): Observable<string> {
          const urlObj: URL = new URL(url);
          const path: string = urlObj.pathname;
          const params: AppsFlyerOneLinkParams = {
            deepLinkValue: path
          };

          return appsFlyerService.generateOneLink(params);
        },
        initializeDeepLinking(): void {
          appsFlyerService.initializeDeepLinking();
        }
      };
    }
  }
);

export interface DeepLinkProvider {
  generateWebLink(path: string): string;
  generateAppsFlyerLink(url: string): Observable<string>;
  initializeDeepLinking(): void;
}
